import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import { Resident } from "@common";
import classNames from "classnames";
import { useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';

const ExistingPaymentMethods = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const {
        state: {
            accounts = null,
            account,
            hasMultipleAccounts,
            setupAccounts
        }
    } = location;
    const { idAccount, residentName } = account;
    const [selectedPM, setSelectedPM] = useState(null);
    const { setSpinnerShow } = useSpinnerContext();
    const [paymentMethods, setPaymentMethods] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async () => {
            setSpinnerShow(true);
            try {
                const response = await sunboundPayProxy.getPayorPaymentMethods({ isActive: true, withAccountAssignments: true });
                const { idAccount: currentAccount } = account;
                let current = null;
                const pmMap = {};
                response.forEach(pm => {
                    const { idPaymentMethod, accountPaymentMethods, sourceName, last4, idPaymentType, accountType } = pm;
                    const acc = {};
                    accountPaymentMethods.forEach(apm => {
                        const { isDefault, accountPayor: { account: { idAccount, residentName } } } = apm;
                        if (idAccount === currentAccount)
                            current = idPaymentMethod;
                        if (isDefault)
                            acc[idAccount] = residentName;
                    });
                    pmMap[idPaymentMethod] = {
                        accounts: acc,
                        sourceName,
                        last4,
                        idPaymentType,
                        idPaymentMethod,
                        accountType
                    }
                });

                setPaymentMethods(pmMap);
                setSelectedPM(current);
            } catch (error) {
                console.error(error);
            }
            setSpinnerShow(false);

        })();
    }, [accounts]);

    const register = async () => {

        setSpinnerShow(true);
        try {

            await sunboundPayProxy.upsertAccountDefaultPaymentMethod(idAccount, selectedPM);

            if (hasMultipleAccounts) {
                if (setupAccounts.length > 0) {
                    const [nextAccount, ...rest] = setupAccounts;
                    helpers.navigateTo(`.`, location, navigate, undefined, { account: nextAccount, setupAccounts: [...rest] });
                } else {
                    helpers.navigateNext(location, navigate, { missingAccounts: false });
                }
            } else {
                const defaultPaymentMethod = { ...paymentMethods[selectedPM] };
                helpers.navigateNext(location, navigate, { hasDefaultPaymentMethod: true }, { defaultPaymentMethod });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSpinnerShow(false);
        }

    };

    const addNew = () => {
        if (hasMultipleAccounts)
            helpers.navigateNext(location, navigate);
        else
            helpers.navigateNext(location, navigate, { hasDefaultPaymentMethod: false });
    }

    console.log(paymentMethods)

    const renderPM = () => {

        const pm = [];
        if (paymentMethods === null) return pm;
        Object.keys(paymentMethods).forEach((key) => {

            const value = paymentMethods[key];
            let assignment = null;
            const { idPaymentMethod, sourceName, last4, accountType, accounts } = value;

            const itemCss = classNames("flex flex-row  p-3 pl-5 rounded-xl border cursor-pointer", { "bg-gray-200 border-gray-300": idPaymentMethod !== selectedPM }, { "bg-blue-text text-white": idPaymentMethod === selectedPM });
            const btnCss = classNames("btn border-2 p-1 ", { "text-blue-on border-blue-on bg-sb-bg": idPaymentMethod !== selectedPM }, { "bg-blue-text text-white border-white": idPaymentMethod === selectedPM });
            const btnText = idPaymentMethod !== selectedPM ? `Select` : `Selected`;
            if (Object.keys(accounts).length !== 0) {
                assignment = (
                    <div>
                        <span>Currently assigned to:</span>
                        <ul role="list" className="list-disc list-inside">
                            {
                                Object.keys(accounts).map(key => {
                                    const residentName = accounts[key];
                                    return (
                                        <li key={residentName}>
                                            <span>{residentName}</span>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>)
            }

            pm.push(
                <div key={idPaymentMethod} className={itemCss} onClick={() => setSelectedPM(idPaymentMethod)}>
                    <div className="w-2/3">
                        <div>
                            <span className="font-bold text-lg">{sourceName}</span>
                        </div>
                        <span>{`${helpers.nullPrint(accountType)} *****${last4}`}</span>
                        {assignment}
                    </div>
                    <div className="w-1/3">
                        <button type="button" className={btnCss}>{btnText}</button>
                    </div>
                </div>
            );
        })
        return pm;
    };

    return (
        <div className="page-content-wrapper gap-y-6">
            <h1 className="page-header">Add Payment Method</h1>
            <span className="page-subheader">We will use this for online payments</span>
            {
                hasMultipleAccounts &&
                <Resident residentName={residentName} />
            }
            <span className="self-start">Existing payment methods:</span>
            <div className="flex flex-col gap-y-6 w-full bg-sb-frame p-7 py-9 rounded-xl border">
                {
                    renderPM()
                }
            </div>
            <div className="flex flex-col page-action gap-y-4">
                <button type="button" className="btn btn-primary" disabled={selectedPM === null} onClick={register}>Register</button>
                <button type="button" className="btn btn-outline-primary rounded-full font-bold text-blue-on text-xl" onClick={addNew}>Add a New Payment Method</button>
            </div>
        </div >
    );
};

export default ExistingPaymentMethods;